/** 表格表头文本列字数限制（与报名字段 fieldNumber 规则一致） */
export const TABLE_FIELD_NUMBER_DEFAULT = 200
export const TABLE_FIELD_NUMBER_MIN = 0
export const TABLE_FIELD_NUMBER_MAX = 2000

/** 单行文本 a、多行文本 b */
export const TABLE_HEADER_TEXT_TYPES = ['a', 'b']

export const parseTableHeaderItem = (item) => {
  const [name, type, content, description, relatedData, relationship, fieldNumber] = item.split('-')
  const normalizedFieldNumber = fieldNumber !== undefined && fieldNumber !== ''
    ? Number(fieldNumber)
    : (TABLE_HEADER_TEXT_TYPES.includes(type) ? TABLE_FIELD_NUMBER_DEFAULT : undefined)

  return {
    name,
    type,
    content,
    description,
    relatedData,
    relationship,
    fieldNumber: normalizedFieldNumber
  }
}

export const serializeTableHeaderItem = (item) => {
  const fieldNumberPart = TABLE_HEADER_TEXT_TYPES.includes(item.type)
    ? (item.fieldNumber ?? TABLE_FIELD_NUMBER_DEFAULT)
    : ''

  return `${ item.name }-${ item.type }-${ item.content || '' }-${ item.description || '' }-${ item.relatedData || '' }-${ item.relationship || '' }-${ fieldNumberPart }`
}
